/* 🤖 this file was generated by svg-to-ts */
export const mgcIconMinimizeCuteFi: {
  name: 'minimize-cute-fi';
  data: string;
} = {
  name: 'minimize-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M4.493 10.594c-.413.143-.798.545-.918.958-.086.297-.06.799.056 1.058.117.263.455.607.725.74l.224.11h14.84l.19-.088c.265-.122.608-.46.74-.728.099-.201.11-.267.11-.644 0-.348-.015-.453-.088-.61-.122-.265-.46-.608-.728-.74l-.224-.11-7.36-.009c-6.982-.008-7.371-.005-7.567.063"/></svg>`
};
